var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.storeFeatureLoadable)?_c('iframe',{attrs:{"src":("https://www.youtube-nocookie.com/embed/" + _vm.videoId + "?rel=0"),"frameborder":"0","allowfullscreen":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }